import theme from '../../config/styles/theme'

export const FEATURE_FLAGS_NAMESPACE = 'cl.chilecompra.datos-abiertos'

export const getEnabledOptions = options => options.filter(option => option.enable)

export const DOWNLOADS_SEARCH_TYPE_OPTIONS = [
  { name: 'Organismo comprador', value: 'entcode', enable: true },
  { name: 'Sector del estado', value: 'sector', enable: true },
  { name: 'Tamaño del proveedor', value: 'tamano', enable: false }
]

export const ENABLED_DOWNLOADS_SEARCH_TYPE_OPTIONS = getEnabledOptions(DOWNLOADS_SEARCH_TYPE_OPTIONS)

export const DOWNLOADS_SEARCH_SECTOR_OPTIONS = [
  { name: 'Fuerzas armadas', value: 'FuerzasArmadas' },
  { name: 'Municipalidades', value: 'Municipalidades' },
  { name: 'Salud', value: 'Salud' },
  { name: 'Obras públicas', value: 'ObrasPublicas' },
  { name: 'Gob. Central/Universidades', value: 'GobCentralUniversidades' },
  { name: 'Legislativo/Judicial', value: 'LegislativoJudicial' },
  { name: 'Otros', value: 'Otros' }
]

export const DOWNLOADS_SEARCH_PROVIDER_OPTIONS = [
  { name: 'Grande', value: 'Grande' },
  { name: 'Mediana', value: 'Mediana' },
  { name: 'Micro', value: 'Micro' },
  { name: 'Pequeña', value: 'Pequena' },
  { name: 'No clasificado', value: 'NoClasificado' }
]

export const DOWNLOADS_REPORT_TYPE_OPTIONS = [
  { name: 'Órdenes de compra', value: 'oc-da' },
  { name: 'Licitaciones', value: 'lic-da' }
]

export const DOWNLOADS_SEMESTER_OPTIONS = [
  { name: 'Primer semestre', value: 'Sem1' },
  { name: 'Segundo semestre', value: 'Sem2' }
]

export const DOWNLOADS_MONTH_OPTIONS = [
  { name: 'Enero', value: '01' },
  { name: 'Febrero', value: '02' },
  { name: 'Marzo', value: '03' },
  { name: 'Abril', value: '04' },
  { name: 'Mayo', value: '05' },
  { name: 'Junio', value: '06' },
  { name: 'Julio', value: '07' },
  { name: 'Agosto', value: '08' },
  { name: 'Septiembre', value: '09' },
  { name: 'Octubre', value: '10' },
  { name: 'Noviembre', value: '11' },
  { name: 'Diciembre', value: '12' }
]
export const MONTHS_DICTIONARY = [
  { name: 'Enero', value: 1 },
  { name: 'Febrero', value: 2 },
  { name: 'Marzo', value: 3 },
  { name: 'Abril', value: 4 },
  { name: 'Mayo', value: 5 },
  { name: 'Junio', value: 6 },
  { name: 'Julio', value: 7 },
  { name: 'Agosto', value: 8 },
  { name: 'Septiembre', value: 9 },
  { name: 'Octubre', value: 10 },
  { name: 'Noviembre', value: 11 },
  { name: 'Diciembre', value: 12 }
]
export const DOWNLOADS_BUCKETS_DICTIONARY = { 'lic-da': 'chc-lic-files', 'oc-da': 'chc-oc-files' }

export const DEFAULT_REGION = 'aysen'

export const DEFAULT_SECTOR = 'municipalidades'

export const BUYERS_DISTRIBUTIONS_DICTIONARY = {
  amountMonthly: 1,
  amountYearly: 2,
  percentageMonthly: 3,
  percentageYearly: 4
}

export const BUYERS_DISTRIBUTIONS_TRANSLATION_DICTIONARY = {
  1: 'amountMonthly',
  2: 'amountYearly',
  3: 'percentageMonthly',
  4: 'percentageYearly'
}

export const BUYERS_DISTRIBUTIONS_OPTIONS = [
  { name: 'Mes del año', value: BUYERS_DISTRIBUTIONS_DICTIONARY.amountMonthly },
  { name: 'Acumulativo anual', value: BUYERS_DISTRIBUTIONS_DICTIONARY.amountYearly },
  { name: 'Monto Porcentual Mensual', value: BUYERS_DISTRIBUTIONS_DICTIONARY.percentageMonthly },
  { name: 'Monto Porcentual Acumulado', value: BUYERS_DISTRIBUTIONS_DICTIONARY.percentageYearly }
]

export const PROVIDERS_INDICATORS_DICTIONARY = { amount: 1, biddings: 2 }
export const DEFAULT_PROVIDERS_FRAMEWORK_INDICATOR = { framework: 1, year: 2023 }

export const PROVIDERS_INDICATORS_NAMES_DICTIONARY = { 1: 'Monto transado', 2: 'N° de licitaciones adjudicadas' }

export const PROVIDERS_INDICATORS_TRANSLATION_DICTIONARY = { 1: 'amount', 2: 'orders' }

export const PROVIDERS_INDICATORS_OPTIONS = [
  { name: 'Monto transado', value: PROVIDERS_INDICATORS_DICTIONARY.amount },
  { name: 'N° de licitaciones adjudicadas', value: PROVIDERS_INDICATORS_DICTIONARY.biddings }
]

export const PROVIDERS_BUYERS_OPTIONS = [
  { name: '1', value: 1 },
  { name: '2', value: 2 }
]

export const SECTOR_DISTRIBUTIONS_DICTIONARY = { amount: 1, biddings: 2, orders: 4, percentage: 2 }

export const SECTOR_DISTRIBUTIONS_OPTIONS = [
  { name: 'Monto transado', value: SECTOR_DISTRIBUTIONS_DICTIONARY.amount },
  { name: 'Porcentaje', value: SECTOR_DISTRIBUTIONS_DICTIONARY.percentage },
  { name: 'N° de licitaciones adjudicadas', value: SECTOR_DISTRIBUTIONS_DICTIONARY.biddings },
  { name: 'N° de órdenes de compra', value: SECTOR_DISTRIBUTIONS_DICTIONARY.orders }
]

export const CURRENCY_VALUES = { USD: 'USD', CLP: '$' }

export const LOCALE_DICTIONARY = { CLP: 'es-CL', USD: 'en-US', CLF: 'es-CL', UTM: 'es-CL', EUR: 'es-ES' }

export const REGION_IMAGE_BASE_URL = '/assets/images/regions/'

export const REGIONS_CAROUSEL = {
  desktop: [
    {
      carouselGroup: 0,
      imageOne: 'arica.jpg',
      imageTwo: 'tarapaca.jpg',
      imageThree: 'antofagasta.jpg',
      nameOne: 'Región de Arica y Parinacota',
      nameTwo: 'Región de Tarapacá',
      nameThree: 'Región de Antofagasta'
    },
    {
      carouselGroup: 1,
      imageOne: 'atacama.jpg',
      imageTwo: 'coquimbo.jpg',
      imageThree: 'valparaiso.jpg',
      nameOne: 'Región de Atacama',
      nameTwo: 'Región de Coquimbo',
      nameThree: 'Región de Valparaíso'
    },
    {
      carouselGroup: 2,
      imageOne: 'metropolitana.jpg',
      imageTwo: 'ohiggins.jpg',
      imageThree: 'maule.jpg',
      nameOne: 'Región Metropolitana de Santiago',
      nameTwo: "Región del Libertador General Bernardo O'Higgins",
      nameThree: 'Región del Maule'
    },
    {
      carouselGroup: 3,
      imageOne: 'nuble.jpg',
      imageTwo: 'biobio.jpg',
      imageThree: 'araucania.jpg',
      nameOne: 'Región de Ñuble',
      nameTwo: 'Región del Biobío',
      nameThree: 'Región de La Araucanía'
    },
    {
      carouselGroup: 4,
      imageOne: 'los-rios.jpg',
      imageTwo: 'los-lagos.jpg',
      imageThree: 'aysen.jpg',
      nameOne: 'Región de Los Ríos',
      nameTwo: 'Región de Los Lagos',
      nameThree: 'Región de Aysén del General Carlos Ibáñez del Campo'
    },
    { carouselGroup: 5, imageOne: 'magallanes.jpg', nameOne: 'Región de Magallanes y de la Antártica Chilena' }
  ],
  mobile: [
    { id: 'AP', image: 'arica.jpg', name: 'Región de Arica y Parinacota' },
    { id: 'TA', image: 'tarapaca.jpg', name: 'Región de Tarapacá' },
    { id: 'AN', image: 'antofagasta.jpg', name: 'Región de Antofagasta' },
    { id: 'AT', image: 'atacama.jpg', name: 'Región de Atacama' },
    { id: 'CO', image: 'coquimbo.jpg', name: 'Región de Coquimbo' },
    { id: 'VA', image: 'valparaiso.jpg', name: 'Región de Valparaíso' },
    { id: 'RM', image: 'metropolitana.jpg', name: 'Región Metropolitana de Santiago' },
    { id: 'LI', image: 'ohiggins.jpg', name: "Región del Libertador General Bernardo O'Higgins" },
    { id: 'ML', image: 'maule.jpg', name: 'Región del Maule' },
    { id: 'NB', image: 'nuble.jpg', name: 'Región de Ñuble' },
    { id: 'BI', image: 'biobio.jpg', name: 'Región del Biobío' },
    { id: 'AR', image: 'araucania.jpg', name: 'Región de La Araucanía' },
    { id: 'LR', image: 'los-rios.jpg', name: 'Región de Los Ríos' },
    { id: 'LL', image: 'los-lagos.jpg', name: 'Región de Los Lagos' },
    { id: 'AI', image: 'aysen.jpg', name: 'Región de Aysén del General Carlos Ibáñez del Campo' },
    { id: 'MA', image: 'magallanes.jpg', name: 'Región de Magallanes y de la Antártica Chilena' }
  ]
}

export const PROFILES = [
  { name: 'Proveedor', value: 1 },
  { name: 'Comprador', value: 2 }
]

export const OPTION_ALL = 8
export const OPTION_FILTER_SECTORS = [8, 7, 6, 5, 4, 3, 2, 1]
export const OPTION_FILTER_SECTORS_AGILE = [8, 7, 6, 5, 4, 3, 2, 1, 0]

export const COVID_IMAGE_URL = '/assets/images/Banner-Covid.svg'

export const NEXT_TYPES_DICTIONARY = {
  categories: 'products',
  families: 'categories',
  initial: 'segments',
  segments: 'families'
}

export const PROVIDERS_TYPE = [
  { name: '1.0', value: 'Grande' },
  { name: '2.0', value: 'Mediana' },
  { name: '3.0', value: 'Pequena' },
  { name: '4.0', value: 'Micro' }
]
export const SEARCH_TYPES = [
  { name: 'RUT', value: 1 },
  { name: 'Razón Social', value: 2 }
]

export const DISTRIBUTION_DICTIONARY = { Accumulated: 1, Monthly: 2 }
export const INDICATORS_DICTIONARY = { amount: 1, orders: 2 }

export const DISTRIBUTION_OPTIONS = [
  { name: 'Acumulada', value: DISTRIBUTION_DICTIONARY.Accumulated },
  { name: 'Mensual', value: DISTRIBUTION_DICTIONARY.Monthly }
]

export const DISTRIBUTION_TRANSLATION_DICTIONARY = { 1: 'Accumulated', 2: 'Monthly' }

export const INDICATORS_OPTIONS = [
  { name: 'Monto transado', value: INDICATORS_DICTIONARY.amount },
  { name: 'N° Órdenes de compra', value: INDICATORS_DICTIONARY.orders }
]

export const INDICATORS_TRANSLATION_DICTIONARY = {
  1: 'amount',
  2: 'orders'
}

export const SECTORS_COLORS = [
  { name: 'Fuerzas Armadas', value: 1, color: theme.palette.charts.cobalt },
  { name: 'Gobierno Central, Universidades', value: 2, color: theme.palette.charts.purpleHeart },
  { name: 'Legislativo y Judicial', value: 3, color: theme.palette.charts.lightenNavyBlue },
  { name: 'Municipalidades', value: 4, color: theme.palette.charts.apple },
  { name: 'Obras Públicas', value: 5, color: theme.palette.charts.saffron },
  { name: 'Otros', value: 6, color: theme.palette.charts.tonysPink },
  { name: 'Salud', value: 7, color: theme.palette.charts.darkRed },
  { name: 'Todos', value: 8, color: theme.palette.charts.deepSaffron },
  { name: 'Total Compra Ágil', value: 0, color: theme.palette.charts.tangerine }
]
export const EMT_COLORS = [
  { name: 'Micro', value: 1, color: theme.palette.charts.tangerine },
  { name: 'Pequeña', value: 2, color: theme.palette.charts.purpureus },
  { name: 'Mediana', value: 3, color: theme.palette.charts.orangeYellowCrayola }
]

export const INDICATORS_EMT_TRANSLATION_DICTIONARY = {
  1: 'amount',
  2: 'orders',
  3: 'quantity'
}

export const INDICATORS_EMT_DICTIONARY = {
  amount: 1,
  orders: 2,
  quantity: 3
}

export const INDICATORS_EMT_OPTIONS = [
  { name: 'Monto transado', value: INDICATORS_EMT_DICTIONARY.amount },
  { name: 'Órdenes de compra', value: INDICATORS_EMT_DICTIONARY.orders },
  { name: 'Ofertas a licitaciones', value: INDICATORS_EMT_DICTIONARY.quantity }
]

export const REGIONS_ALL = 30

export const COMPANIES_COLORS = [
  { name: 'Total Transado', value: 0, color: theme.palette.charts.navyBlue },
  { name: 'Empresas de Menor Tamaño', value: 1, color: theme.palette.charts.orangeYellowCrayola }
]

export const DISTRIBUTION_EMT_OPTIONS = [
  { name: 'Acumulada', value: DISTRIBUTION_DICTIONARY.Accumulated },
  { name: 'Mes del año', value: DISTRIBUTION_DICTIONARY.Monthly }
]

export const PARTICIPATIONS_COLORS = [
  { name: 'Ofertas enviadas a Licitaciones por EMT', value: 0, color: theme.palette.charts.ruby },
  { name: 'Cotizaciones Compra Ágil por EMT', value: 1, color: theme.palette.charts.grape },
  { name: 'Órdenes de compra recibidas por EMT', value: 2, color: theme.palette.charts.dodgerBlue },
  { name: 'Participación EMT', value: 3, color: theme.palette.charts.teal }
]

export const NEXT_TYPES_DICTIONARY_VALUES = [
  { name: 'segments', value: 1 },
  { name: 'families', value: 2 },
  { name: 'categories', value: 3 },
  { name: 'products', value: 4 }
]
